module.exports = __webpack_public_path__ + "static/media/logo-ekodom.7dac8f18.svg";